// ./src/utils/analytics/privacy.ts
//
// WHAT MAY LEAVE FOR GOOGLE (ROADMAP #62 P7). GA reads the page's full URL into every hit unless told otherwise — and
// three of this app's links carry a SECRET in the query string: `?token=` (password reset, accept an invitation) and
// `?inv=` (a crew member's access link). Before P7 each of those went to Google with the page view.
//
// ⚠ An ALLOW-list, not a deny-list: a new secret-bearing parameter must not need remembering here. Only the campaign
//   tags GA reads for attribution survive.
// ⚠ Pure, so `check-analytics` RUNS it.

// `safePageLocation` (the URL allow-list) is shared with the marketing websites: `@em/utils/analyticsPrivacy`.
export { safePageLocation } from '@em/utils/analyticsPrivacy';

const MAX_TERM = 60;
const MAX_TERM_WORDS = 4;

/**
 * A host's type-search words, as the funnel may record a MISS (`wizard_type_search`; a pick sends the catalog's own word
 * instead — see `funnel.ts`). GA must never receive personal data, so:
 *   - anything that looks like contact details — an `@`, or a run of five digits (a phone number) — drops the term whole;
 *   - a POSSESSIVE word ("emma's", "smiths’") is removed: it is how a name gets typed into a type search;
 *   - more than four words is not a type search, and is not sent.
 * Lower-cased and squeezed. Null when nothing is left.
 * ⚠ A bare name typed alone would still pass — a residual risk accepted for misses (ROADMAP P7).
 */
export const cleanSearchTerm = (term: string | null | undefined): string | null => {
  const squeezed = (term ?? '').toLowerCase().replace(/\s+/g, ' ').trim();

  if (!squeezed || squeezed.includes('@') || /\d{5,}/.test(squeezed.replace(/[\s().+-]/g, ''))) {
    return null;
  }

  const words = squeezed.split(' ').filter((w) => !/['’]s?$/.test(w));

  if (words.length === 0 || words.length > MAX_TERM_WORDS) {
    return null;
  }

  return words.join(' ').slice(0, MAX_TERM);
};
